module.exports = __webpack_public_path__ + "img/account-img.png";